module.exports = __webpack_public_path__ + "statics/img/cate3-2@2x.11449f0b.png";